/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PaymentDetailsEditor extends _Ext.GridEditorBase<PaymentDetailsRow> {
        protected getColumnsKey() { return "Finance.PaymentDetails"; }
        protected getDialogType() { return PaymentDetailsDialog; }
        protected getLocalTextPrefix() { return PaymentDetailsRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as PaymentDialog).calculateTotals();
                }
            })
        } 
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.LedgerId === row.LedgerId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Ledger is already in order details!');
                return false;
            }
            row.LedgerName = OMS.AccountLedgerRow.getLookup().itemById[row.LedgerId].LedgerName; 
            return true;
        }

        

    }
}